module.exports = __webpack_public_path__ + "assets/img/NPC022.e2ed5bf1.png";